import { render } from "./FindSinister.vue?vue&type=template&id=519bf3d2"
import script from "./FindSinister.vue?vue&type=script&lang=js"
export * from "./FindSinister.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/extranet-sinistre/production/client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__